import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	title: {
		id: 'dtcPartnership.payment.title',
		defaultMessage: "Great! Here's how your offer works.",
		description: 'Title explaining that the offer will be described',
	},
});
